import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import { createRoot } from 'react-dom/client';
import "./i18n";

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/*" element={<App />} />
    </Routes>
  </BrowserRouter>
);
